/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { TechwiseNotification } from "../../utils/Interfaces";

export interface TechwiseNotifications {
    notifications: TechwiseNotification[];
}

const initialState: TechwiseNotifications = {
    notifications: [],
};

export const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        pushUpdatedNotifications: (state, action: PayloadAction<TechwiseNotification[]>) => {
            let mutable: TechwiseNotification[] = [...state.notifications];

            let toAdd: TechwiseNotification[] = [];

            action.payload.map((newNotification: TechwiseNotification) => {
                let matches: TechwiseNotification[] = mutable
                    .filter(
                        (existingNotification: TechwiseNotification) =>
                            existingNotification.notification_type === newNotification.notification_type
                    )
                    .filter((existingNotification: TechwiseNotification) => existingNotification.id === newNotification.id);

                // If the notification matches an existing notification (should only ever be one, but this code will
                // update multiple), update the notification reference.
                matches.map((_: TechwiseNotification, index: number) => {
                    matches[index] = newNotification;
                    return null;
                });

                // If the notification is new, queue it up to be added to the existing queries list.
                if (matches.length === 0) {
                    toAdd.push(newNotification);
                }

                return null;
            });

            toAdd.map((newNotification: TechwiseNotification) => mutable.push(newNotification));

            let toRemove: TechwiseNotification[] = [];

            mutable.map((existingNotification: TechwiseNotification) => {
                let newIds: number[] = action.payload
                    .filter(
                        (newNotification: TechwiseNotification) =>
                            newNotification.notification_type === existingNotification.notification_type
                    )
                    .map((newNotification: TechwiseNotification) => newNotification.id);

                if (!newIds.includes(existingNotification.id)) {
                    toRemove.push(existingNotification);
                }
                return null;
            });

            toRemove.map((existingNotification: TechwiseNotification) =>
                mutable.splice(mutable.indexOf(existingNotification), 1)
            );

            state.notifications = mutable;
        },
    },
});

export const { pushUpdatedNotifications } = notificationsSlice.actions;

export const selectNotifications = (state: RootState) => state.notifications.notifications;

export default notificationsSlice.reducer;
